export default "__VITE_ASSET__76cef6c6__"